<template>
    <div>
        <label :for="selectName" class="label" :class="{ 'sr-only': !hiddenLabel }">{{ label }}</label>
        <div class="select-wrapper">
        <select ref="select" 
            :class="className"
            :name="selectName" 
            :id="selectName" 
            v-model="selectedOption"
            :disabled="disabled">
            <option v-for="o in filteredOptions" 
                    v-bind:key="o.text" 
                    :value="o.value">
                {{ o.text }} 
            </option>
        </select>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data: function () {
        return {
            selectedOption: '',
        }
    },  
    props: {
        options: Array,
        selectName: String,
        label: String,
        hiddenLabel: String,
        selected: String,
        disabled: Boolean,
        className: String
    },
    computed: {
        ...mapGetters({
            'site': 'search/site'
        }),
        'initialOption': function () {
            return this.$refs.select.querySelector('option').value;
        },
        'filteredOptions': function () {
            return this.options.filter(opt => {
                if (opt.display) {
                    return opt.display == this.site;
                } else {
                    return opt;
                }
            })
        }
    },
    watch: {
        'selectedOption' (value) {
            this.$emit('update', value);
        },
        'selected' (value) {
            this.selectedOption = value.length ? value : 'all';
        }
    },
    methods: {
        resetSelected () {
            this.selectedOption = this.initialOption;
        }
    },
    async mounted() {
        if (!this.selected) {
            this.selectedOption = this.initialOption;
        } else {
            this.selectedOption = this.selected;
        }
    }
}
</script>

<style scoped lang="scss">
    label.label {
        display: inline-block;
        margin-bottom: .5rem;
        margin-top: 1.8rem;
        font-size: .9rem;
    }

    select {
        height: 51px;
        color: $dark-gray1;
        font-size: .875rem;
        text-transform: uppercase;
        font-weight: bold;
        padding: .5rem 1rem;
        border: none;
        max-width: 280px;
        text-overflow: ellipsis;
        margin-right: .5rem;
        -webkit-appearance: none;
        -moz-appearance: none;
        padding-right: 60px;
        background: $white;
        
        &:focus, &:active {
            border: none;
            outline-offset: 2px;
        }
        &#savedListSortBy,
        &#sortBy {
            text-transform: none;
            font-family: $futura;
            font-size: 1rem;
            font-weight: 500;
            background: $off-white;
            max-width: 280px;
            margin-right: 0;
        }
        &#savedListSortBy{
            background: $white;
        }
    }

    .select-wrapper {
        position: relative;
        width: fit-content;
        &:after {
            position: absolute;
            top: 16px;
            right: 18px;
            pointer-events: none;
            content: url('../assets/images/icon-dropdown-menu-arrow.svg');
        }
    }
    
    .full-width {
        flex-basis: 31.5%;
        display: flex;
        padding-left: 5px;
        box-sizing: border-box;
        position: relative;
        margin: .25rem 0;

        .label {
            width: $label-spacing;
            margin-right: 0;
            padding-right: .5rem;
            box-sizing: border-box;
            text-align: right;
        }
        select {
            flex-grow: 1;
            width: 240px;
            margin-right: 0;
        }
        &:nth-child(1), &:nth-child(4) {
            padding-left: 0;
            label {
                text-align: left;
                margin-right: 0;
                flex-shrink: 0;
                width: $label-spacing;
                font-weight: normal;
            }

            select {
                width: 260px;
            }
        }
    }


    .sort-dropdown {
        display: flex;
        align-items: center;
        label {
            display: inline-block;
            text-transform: none;
            margin: 0;
            margin-right: .8rem;
        }
    }

    @media (max-width: 1280px) {
        .full-width {
            flex: 0 0 250px;
            flex-direction: column;
            padding-left: 0;
            padding-right: .5rem;

            .label {
                text-align: left;
                width: unset;
            }

            select {
                width: 100%;
            }

            &:nth-child(1), &:nth-child(4) {
                select {
                    width: 100%;
                }
            }
        }
    }

    @media (max-width: $mq-max-width-tablet) {
        select {
            max-width: 120px;
            padding-right: 40px;
        }
        .full-width select {
            width: 100%;
            max-width: unset;
        }
    }
    @media (max-width: $mq-max-width-mobile) {
        select.filter-input {
            max-width: unset;
            width: 100%;
        }
        .full-width {
            flex-basis: 100%;
            flex-direction: column;
            padding-left: 0;
            padding-right: .5rem;

            .label {
                text-align: left;
            }

            select {
                width: 100%;
                max-width: unset;
            }

            &:nth-child(1), &:nth-child(4) {
                select {
                    width: 100%;
                }
            }
        }
    }
    @media (max-width: $mq-max-width-mobile-sml) {
        select#sortBy {
            max-width: 115px;
        }
    }
</style>